import classes from "../ServicesTable.module.scss"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useContext, useEffect, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { servicesEditFields } from "./servicesColumns";
import Button from "../../UI/Button";
import ServiceForm from "./ServiceForm";
import { OrgIdContext } from "../../../store/orgId_context";
import EditOffIcon from '@mui/icons-material/EditOff';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import InputIcon from '@mui/icons-material/Input';
import OutputIcon from '@mui/icons-material/Output';
import { useTranslation } from "react-i18next";

const ServicesTableTrNonEdit = ({data:inputData, index, tableInfo, onSubmit}) => {
    const [editable, setEditable] = useState();
    const [data, setData] = useState({})
    const { isMaintainer } = useContext(OrgIdContext);
    const {t} = useTranslation();
    const [showForm, setShowForm] = useState(false);

    const onTrClick = () =>{
        if(!editable)
            return;
        setShowForm(prev => !prev);
    }

//#region field helpers
    const getFieldKey = (fieldName) => {
        if(data.hasOwnProperty(fieldName))
            return fieldName;

        return getFullFieldKey(fieldName);
    }
    const getFullFieldKey = (fieldName) => {
        let field = servicesEditFields.filter(obj => obj.name === fieldName)[0];
        let append = "";
        if(field && field.groupFields){
            field.groupFields.forEach(val => append = append+val+"__")

        }
        return append+fieldName;
    }
    const getHardcodedFieldInfo = (fieldName) =>{
        return servicesEditFields.filter(obj => obj.name === fieldName)[0];
    }
    const getFieldValue = (fieldName) => {
        if(data.hasOwnProperty(fieldName))
            return data[fieldName];
        if(data.hasOwnProperty(getFullFieldKey(fieldName)))
            return data[getFullFieldKey(fieldName)]
        return null;
    }

//#endregion
    const getIconForDirection = (direction) =>{
        switch(direction){
            case "Recieve":
                return <InputIcon className="main-blue"/>
            case "Send":
                return <OutputIcon className="main-blue"/>
            case "Both":
                return <ImportExportIcon className="main-blue"/>
            case "PushREI":
                return <OutputIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "PushIEI":
                return <OutputIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "Push":
                return <OutputIcon className="main-blue"/>
            default:
                return <OutboxIcon className="main-blue"/>
        }
    }
    const getIconForType = (type) =>{
        switch(type){
            case "PublicSector":
                return <PublicIcon className="main-blue"/>
            case "PrivateSector":
                return <PublicOffIcon className="main-blue"/>
            case "All":
                return <AllInclusiveIcon className="main-blue"/>
            default:
                return <AllInclusiveIcon className="main-blue"/>
        }
    }

    const getTooltipTextForDirection = (direction) =>{
        switch(direction){
            case "Recieve":
                return t("This service is designed to receive data from external sources.")
            case "Send":
                return t("This service is designed to send data to external recipients.")
            case "Both":
                return t("This service is designed to both send data to and receive data from external sources.")
            case "PushREI":
                return t("This service is designed to send data to external recipients (Specifically for received invoices).")
            case "PushIEI":
                return t("This service is designed to send data to external recipients (Specifically for issued invoices).")
            case "Push":
                return t("This service is designed to send data to external recipients.")
            default:
                return t("Unknown direction")
        }
    }

    useEffect(() => {
        if(!inputData)
            return setEditable(false);
        if(inputData["ServiceEndPointCode__NonCustomerEditable"])
            return setEditable(false);
        if(isMaintainer && inputData.ServiceEndPointCode__MaintainerUIRules && inputData.ServiceEndPointCode__MaintainerUIRules.length > 0)
            return setEditable(true);
        if(inputData.ServiceEndPointCode__UserUIRules && inputData.ServiceEndPointCode__UserUIRules.length>0)
            return setEditable(true);
        setEditable(false);
    }, [inputData]);
    
    useEffect(()=>{
        if(inputData){
            setData(inputData);
        }
    }, [inputData])

    const onFormSubmit = (data, res) =>{
        if(onSubmit)
            onSubmit(data, res);
    }
    
    return (
    <>
        <Container className={`${classes["rowContainer"]} g-0`} style={index%2===0 ? {backgroundColor:"#f1f5fd"} : {backgroundColor:"#f9fbff"}}>
            <Row  className={`${classes["tableRow"]} g-0`} onClick={onTrClick} style={editable ? {cursor:"pointer"} : {}}>
                <Col className={`col-1 ${classes["trcol"]}`}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{data["ServiceEndPointCode__Step__StepDescription"]||data["Step__StepDescription"]}</Tooltip>}>
                        <i className={classes["stepCircle"]}>{data["ServiceEndPointCode__Step"] || data["Step"]}</i>
                    </OverlayTrigger>
                </Col> 
                <Col className={`col-5 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem", fontWeight:"bold"}}>
                    {getFieldValue("ServiceEndPointCode__Step__StepDescription") || getFieldValue("Step__StepDescription") || getFieldValue("Description") || getFieldValue("ServiceEndPointCode")}
                </Col>

                <Col className={`col-2 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem"}}>
                    {data["ServiceEndPointCode"]}
                </Col>
                
                <Col className={`col-2 ${classes["trcol"]}`}>{data["ServiceEndPointCode__Purpose"]||data["Purpose"]}</Col>
                <Col className={`col-1 ${classes["trcol"]}`} style={{color:"#005683"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{getTooltipTextForDirection(getFieldValue("Direction"))}</Tooltip>}>
                        {getIconForDirection(getFieldValue("Direction"))}
                    </OverlayTrigger>
                </Col>
                {/* <Col className={`col-1 ${classes["trcol"]}`}>
                    {data["Valid"] === true && <CheckCircleIcon style={{color:"green"}}/>}
                    {data["Valid"] !==true && <UnpublishedIcon style={{color:"#005683"}}/>}
                </Col> */}
                <Col className={`col-1 ${classes["trcol"]}`} style={{color:"#005683"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{data["ServiceEndPointCode__Type"]||data["Type"]}</Tooltip>}>
                        {getIconForType(getFieldValue("Type"))}
                    </OverlayTrigger>
                </Col>
                {/* <Col className={`col-1 ${classes["trcollast"]}`} style={{textAlign:"right", paddingRight:"1rem"}}>
                    {!editable && <EditOffIcon style={{fontSize:"1rem"}}/>}
                    {editable  && !showForm && <><KeyboardArrowLeftIcon style={{fontSize:"1rem", color:"#318300"}}/> <ModeEditIcon className={classes["editIcon"]} style={{fontSize:"1rem", color:"#318300"}}/></>}
                    {editable  && showForm && <KeyboardArrowDownIcon style={{fontSize:"1.3rem", color:"#318300"}}/>}
                </Col> */}
            </Row>
            {showForm &&
            <Row className={classes["formRow"]}>
                <Col>
                    <ServiceForm data={data} info={tableInfo} onSubmit={onFormSubmit}/>
                </Col>
            </Row>
            }
        </Container>
    </>
    )
}

export default ServicesTableTrNonEdit;